import React from 'react';
import { cn } from '@/lib/utils';

interface HeadingProps {
  children: React.ReactNode;
  level?: 1 | 2 | 3 | 4 | 5 | 6;
  className?: string;
  gradient?: boolean;
}

const Heading: React.FC<HeadingProps> = ({ 
  children, 
  level = 2, 
  className,
  gradient = false
}) => {
  const classes = cn(
    'font-bold font-heading',
    gradient && 'gradient-text',
    className
  );

  switch (level) {
    case 1:
      return <h1 className={cn('text-4xl md:text-5xl mb-6', classes)}>{children}</h1>;
    case 2:
      return <h2 className={cn('text-3xl md:text-4xl mb-5', classes)}>{children}</h2>;
    case 3:
      return <h3 className={cn('text-2xl md:text-3xl mb-4', classes)}>{children}</h3>;
    case 4:
      return <h4 className={cn('text-xl md:text-2xl mb-3', classes)}>{children}</h4>;
    case 5:
      return <h5 className={cn('text-lg md:text-xl mb-2', classes)}>{children}</h5>;
    case 6:
      return <h6 className={cn('text-base md:text-lg mb-2', classes)}>{children}</h6>;
    default:
      return <h2 className={cn('text-3xl md:text-4xl mb-5', classes)}>{children}</h2>;
  }
};

export default Heading;